import BasePreloader from 'Preloader/BasePreloader';
import 'Preloader/index.css';
import './index.css';

import { getBrandingPreloader } from '../../branding/branding';

export default new (getBrandingPreloader() || BasePreloader);
